import { useLazyQuery } from '@apollo/client/react';
import { useAtom } from 'jotai';
import { useEffect, useMemo } from 'react';

import { GetEventsDocument } from '~/graphql/generated/graphql';
import { messageModalState } from '~/state/partials/message_modal/atoms';

export const useFetchMessageEvents = () => {
  const [{ patientId, profile, page, perPage }, setState] = useAtom(messageModalState);
  const [getEvents, { called, loading, data }] = useLazyQuery(GetEventsDocument, {
    fetchPolicy: 'network-only',
    nextFetchPolicy: 'cache-and-network',
  });

  const events = useMemo(() => (data ? data?.events?.nodes || [] : []), [data]);

  useEffect(() => {
    if (!data || loading) return;

    setState((_state) => ({ ..._state, totalPage: data.events?.pagesCount ?? 1 }));
  }, [data, loading, setState]);
  useEffect(() => {
    if (patientId && profile) {
      getEvents({
        variables: {
          page,
          perPage,
          patientId: profile.type === 'Patient' ? patientId : undefined,
          guestPatientId: profile.type !== 'Patient' ? patientId : undefined,
        },
      });
    }
  }, [getEvents, page, patientId, perPage, profile]);

  return {
    loading: !called || loading,
    events,
  };
};
